import React, { useRef } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useInView } from "framer-motion"

import { SliderImage } from "../../components/SliderImage"
import { BlogListSlider } from "../../components/BlogListSlider"
import BlogInterest from "../../components/BlogInterest/BlogInterest"
import { GlobalStaffingSnapshot } from "../../components/PageContent"
import { FluidSlider } from "../../components/PageHero"

const HomePageTemplate = ({ data }) => {
  const content = useStaticQuery(graphql`
    query {
      allContentfulHomePageMediaSlider(sort: { fields: slideSequence }) {
        edges {
          node {
            id
            portfolioTitle
            description {
              description
            }
            portfolioImage {
              gatsbyImageData(width: 2400, quality: 100)
            }
            videoMediaLink
            buttonLabel
            buttonLink
            openInNewTab
            isNoFollow
            language
          }
        }
      }
    }
  `)
  
  let portfolioSliderEdges = content.allContentfulHomePageMediaSlider.edges
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  
  // const portfolioSliderEdgesFilter = portfolioSliderEdges.filter(
  //   (item) => item.node.language === data.pageLanguage || item.node.language === null
  // );

  const hasMatchingLanguage = portfolioSliderEdges.some(
    (item) => item.node.language === data.pageLanguage
  );
  
  const portfolioSliderEdgesFilter = portfolioSliderEdges.filter((item) => {
    if (hasMatchingLanguage) {
      return item.node.language === data.pageLanguage;
    } else {
      return item.node.language === null;
    }
  });

  console.log('home file Hero Slider',data.heroSliderLists)
  
  return (
    <div>
      <FluidSlider heroSliderLists={data.heroSliderLists} />
      <section id="home-image-slider">
        <SliderImage slides={portfolioSliderEdgesFilter} />
        <div ref={ref} id="home-blog">
          <div className="flex align-center">
            <h3 style={{ opacity: isInView ? 1 : 0, transition: "all 0.3s cubic-bezier(0.17, 0.55, 0.55, 1) 0.3s"}} className="text-5xl extrabold family-open-sans ma-0 pl-40 uppercase">{data.blogTitle}</h3>
          </div>
          <div style={{opacity: isInView ? 1 : 0, transition: "all 0.6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.6s"}} >
            {data.blogListPicker !== null ? (
              <div className="pl-40">
                {data.blogListPicker.length !== 0 && (
                  <BlogInterest content={data.blogListPicker} hasCustomClass={false} hasTitle={false} hasDate={false} />
                )}
              </div>
            ) : (
              <BlogListSlider showLast={5} className="pl-40" />
            )}
          </div>
        </div>
        <GlobalStaffingSnapshot location={data.worldwideStateAndCountryCatalog} />
      </section>
    </div>
  )
}

export default HomePageTemplate
